/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewreach1Inputs */

const en_overviewreach1 = /** @type {(inputs: Overviewreach1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach`)
};

const de_overviewreach1 = /** @type {(inputs: Overviewreach1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reichweite`)
};

/**
* | output |
* | --- |
* | "Reach" |
*
* @param {Overviewreach1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewreach1 = /** @type {((inputs?: Overviewreach1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewreach1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewreach1(inputs)
	return de_overviewreach1(inputs)
});
export { overviewreach1 as "overviewReach" }